module.exports = __webpack_public_path__ + "static/img/icon_host_arrow.b96f2038.svg";